var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ctn"},[(!_vm.opened)?_c('div',{staticClass:"icon el-icon-folder"}):_vm._e(),(_vm.opened)?_c('div',{staticClass:"icon el-icon-folder-opened"}):_vm._e(),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.dir.Name))])])}
var staticRenderFns = []

export { render, staticRenderFns }